import React from 'react';

import { getInitials } from '../services/function';

const UserAcronym: React.FC<any> = ({ name, color }: any) => {
  const initials = getInitials(name);
  return (
    <div>
      <span
        className="ms-2 my-2 fw-bold"
        style={{
          backgroundColor: color,
          color: '#fff',
          width: '2rem',
          height: '2rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '0.6875rem',
        }}
      >
        {initials}
      </span>
    </div>
  );
};

export default UserAcronym;
